import { hashHistory } from 'react-router';

let preventRedirect: boolean | null = null;

export const redirectTo = (url, skip = false, clientId = '') => {
  // Always use plugin mode (hash-based routing)
  if (preventRedirect) {
    hashHistory.replace(url + clientId);
  }
  else {
    const location = hashHistory.getCurrentLocation();
    hashHistory.push({
      ...location,
      pathname: url,
      search: clientId
    })
  }
  preventRedirect = skip;
}
